import { z } from 'zod'
import { Currency } from '../../../enums/currency.enum'
import { isoDate } from './iso-date'

// `categoryId` accepts either a real category uuid or the `'uncategorized'`
// sentinel emitted for shared-expense leftovers where the viewer cannot see
// the per-split category.
const categoryIdSchema = z.union([z.literal('uncategorized'), z.string().guid()])

export const categoryExpensesQuerySchema = z
  .object({
    categoryId: categoryIdSchema,
    from: isoDate,
    to: isoDate,
    baseCurrency: z.nativeEnum(Currency).optional(),
  })
  .refine((q) => q.from <= q.to, { message: 'from must be on or before to', path: ['from'] })

export type CategoryExpensesQueryDto = z.infer<typeof categoryExpensesQuerySchema>

export const categoryExpensesItemSchema = z.object({
  id: z.string().guid(),
  date: z.string(),
  description: z.string().nullable(),
  amount: z.number(),
  currency: z.string(),
  convertedAmount: z.number(),
  accountId: z.string().guid(),
  accountName: z.string(),
})

export type CategoryExpensesItemDto = z.infer<typeof categoryExpensesItemSchema>

export const categoryExpensesResponseSchema = z.object({
  baseCurrency: z.nativeEnum(Currency),
  // mirrors the request: a real category uuid or the `'uncategorized'` sentinel
  // returned for shared-expense leftovers where the viewer cannot see the
  // per-split category.
  categoryId: categoryIdSchema,
  items: z.array(categoryExpensesItemSchema),
  skippedExpenseCount: z.number().int().nonnegative(),
})

export type CategoryExpensesResponseDto = z.infer<typeof categoryExpensesResponseSchema>
